import { css } from "@emotion/react";

export const antdStyle = css`
  ::-webkit-scrollbar {
    width: 5px;
    height: 8px;
  }
  ::-webkit-scrollbar-thumb {
    background-color: rgba(170, 170, 170, 0.41);
    border-radius: 6px;
  }
  ::-webkit-scrollbar-track {
    background-color: transparent;
    transition:
      background-color 0.2s linear,
      width 0.2s ease-in-out;
  }
  ::-webkit-scrollbar-corner {
    background-color: rgba(0, 0, 0, 0);
  }
  .ant-picker-dropdown.custom-picker-dropdown .ant-picker-panel-container {
    .ant-picker-presets {
      width: 236px;
      max-width: 236px;
      > ul {
        display: grid;
        grid-template-columns: 1fr 1fr;
        grid-template-rows: repeat(auto-fill, 34px);
        gap: 8px;
        li {
          margin-top: 0;
          padding-inline: 0;
          .ant-btn {
            width: 100%;
          }
          &:last-child {
            grid-column: 1/3;
          }
        }
      }
    }
  }
  .react-grid-layout {
    transition: none !important;
    .react-grid-item {
      transition: none !important;
    }
  }
`;
